import { CheckCircleFilled } from '@ant-design/icons';
import colorTokens from '../../constants/design_system/colors';
import CustomTooltip from '../UI/Tooltip/CustomTooltip';

export type SelectableCardProps = {
  id: string;
  title: string;
  subtitle: string;
  selected: boolean;
  onSelected: (id: string) => void;
  disabled?: boolean;
  disabledTooltip?: string;
};

export const SelectableCard = (props: SelectableCardProps) => {
  const { id, title, subtitle, selected, onSelected, disabled, disabledTooltip } = props;

  return (
    <CustomTooltip title={disabledTooltip}>
      <div
        style={{ borderColor: props.selected ? colorTokens.blue[600] : colorTokens.neutral[300] }}
        className={`px-4 py-3 rounded-lg border-solid border-2 border-blue-600 flex-col justify-start items-start gap-3 grow basis-1/2 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        onClick={() => !disabled && onSelected(id)}
      >
        <div className="w-full justify-between items-center inline-flex">
          <div className="justify-start items-center gap-2 flex">
            <div className="text-brand-grey-dark text-base font-semibold leading-normal">{title}</div>
          </div>
          {selected && <CheckCircleFilled style={{ fontSize: '16px' }} className="text-blue-500" />}
          {!selected && <div className="w-[14px] h-[14px] rounded-lg border border-solid border-neutral-600" />}
        </div>
        <div className="self-stretch text-neutral-900 text-xs font-normal leading-none mt-2">{subtitle}</div>
      </div>
    </CustomTooltip>
  );
};
